import ToolbarIconButton from './ToolbarIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarActionButtons = ({
  buttonActions,
  hasDropdown,
  active,
  lastButtonRounding,
  onlyLeftAndRightButtonBorders,
  iconUse
}) => {
  return buttonActions.map(({
    id: actionId,
    callback,
    icon: ActionIcon,
    tooltipLabel,
    disabled,
    placement,
    autoPlacement
  }, i) => {
    const isFirstButtonAfterHandle = i === 0;
    const isLastButton = i === buttonActions.length - 1;
    const cornerToRound = !hasDropdown && isLastButton ? lastButtonRounding : undefined;
    const hasAnyBorder = !isFirstButtonAfterHandle || !onlyLeftAndRightButtonBorders;
    return /*#__PURE__*/_jsx(ToolbarIconButton, {
      icon: ActionIcon,
      use: iconUse,
      isToolbarActive: active,
      disabled: disabled,
      onClick: disabled ? undefined : callback,
      placement: placement,
      autoPlacement: autoPlacement,
      hasAnyBorder: hasAnyBorder,
      onlyLeftAndRightBorders: onlyLeftAndRightButtonBorders,
      cornerToRound: cornerToRound,
      tooltip: tooltipLabel
    }, actionId);
  });
};
export default ToolbarActionButtons;